/**
 * @generated SignedSource<<f5eb2a54fd31a3f5ecfa62274d458162>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeriesSwitcher_viewer$data = {
  readonly account: {
    readonly id: string;
  };
  readonly " $fragmentType": "SeriesSwitcher_viewer";
};
export type SeriesSwitcher_viewer$key = {
  readonly " $data"?: SeriesSwitcher_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SeriesSwitcher_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SeriesSwitcher_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Account",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "617a20b556c17c09bb2d35ff6347d37d";

export default node;
